import React from "react";
import { advertising, salesListings } from "../../mock";
import PropertyCard from "./PropertyCard";
import SwipeRow from "./SwipeRow";
import { ArrowRight } from "lucide-react";

const Advertising = () => {
  return (
    <section id="sales" className="bg-[#f3f1ec]">
      {/* Advertising split */}
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="relative min-h-[420px] lg:min-h-[640px] overflow-hidden group">
          <img src={advertising.image} alt="Advertising" loading="lazy" className="w-full h-full object-cover absolute inset-0 transition-transform duration-[1400ms] group-hover:scale-105" />
        </div>
        <div className="flex flex-col justify-center px-8 md:px-20 py-20 reveal">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">{advertising.eyebrow}</p>
          <h2 className="font-serif-display text-5xl md:text-6xl font-light text-[#1a1a1a] mb-8">{advertising.title}</h2>
          <p className="text-neutral-500 text-[15px] leading-relaxed max-w-lg">{advertising.body}</p>
        </div>
      </div>

      {/* Sales portfolio grid */}
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="flex items-end justify-between mb-12 reveal">
          <div>
            <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-3">Sales Portfolio</p>
            <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a]">Record-Setting Results</h2>
          </div>
          <a href="#sales" className="hidden md:flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] hover:text-[#b4936a] transition-colors border-b border-[#1a1a1a] hover:border-[#b4936a] pb-1">
            View More <ArrowRight size={14} />
          </a>
        </div>
        <div className="reveal">
          <SwipeRow testid="sales-portfolio-swipe">
            {salesListings.map((item) => (
              <PropertyCard key={item.id} item={item} />
            ))}
          </SwipeRow>
        </div>
      </div>
    </section>
  );
};

export default Advertising;
